//** React Imports
import { useEffect, Fragment, ReactNode, useState } from 'react'

// ** Next Imports
import dynamic from 'next/dynamic'

//** Effect Imports
import { useStore } from 'effector-react'

// ** Source Imports
import globalStore from 'src/state-manager/global'
import { useSettings } from 'src/@core/hooks/useSettings'
import landingStore, { getTableForLanding, getLandingDetail } from 'src/state-manager/landing'
import tableColumnKeysConf from 'src/configs/db-columns-keys'
import tableEnumV2OptionsConf from 'src/configs/db-enum-v2-options'
import Spinner from 'src/@core/components/spinner'
import DefaultLayout from 'src/layouts/default-layout'

const keyValuesKeys = tableColumnKeysConf.keyValues
const keyValuesEnum = tableEnumV2OptionsConf.keyValues
const platformsKeys = tableColumnKeysConf.landing_platforms
const platformsEnum = tableEnumV2OptionsConf.landing_platforms

const Platforms = dynamic(() => import('src/views/pages/platforms-page'), {
  ssr: false
})

const PlatformsPage = () => {
  const settings = useSettings()

  const { language } = useStore(globalStore.locale)
  const { landingDetails, platforms } = useStore(landingStore.landing)

  const [loadingMedia, setLoadingMedia] = useState(true)

  useEffect(() => {
    getLandingDetail({
      query: {
        $or: [{ 'data.groupName': 'landing' }, { 'data.groupName': 'shared' }],
        $and: [
          {
            [`data.${keyValuesKeys.language}`]:
              language === 'ru' ? keyValuesEnum.language.ru : keyValuesEnum.language.en
          }
        ]
      }
    })

    getTableForLanding({
      key: 'platforms',
      tableName: 'landing_platforms',
      query: {
        $and: [
          {
            [`data.${platformsKeys.language}`]:
              language === 'ru' ? platformsEnum.language.ru : platformsEnum.language.en
          }
        ]
      }
    })
  }, [language])

  const isLoading = landingDetails.loading || platforms.loading || loadingMedia

  return (
    <Fragment>
      {isLoading && <Spinner settings={settings} />}
      <DefaultLayout
        sx={{
          height: isLoading ? 0 : 'auto',
          visibility: isLoading ? 'hidden' : 'visible'
        }}
      >
        <Platforms landingDetails={landingDetails.data} platforms={platforms} setLoadingMedia={setLoadingMedia} />
      </DefaultLayout>
    </Fragment>
  )
}

PlatformsPage.getLayout = (page: ReactNode) => page

PlatformsPage.acl = {
  action: 'read',
  subject: 'platforms-page'
}

export default PlatformsPage
